import { type FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import {
  H1,
  StringMain,
  StringXSmall,
} from '@/components/Typography/Typography';

import { LoginButtonsSection } from '../LoginButtonsSection/LoginButtonsSection';

import css from './styles.module.scss';

interface LoginSectionProps {
  nextLoginStep: () => void;
}

const LoginSection: FC<LoginSectionProps> = () => {
  const { t } = useTranslation();

  return (
    <article className={css.login}>
      <H1 className="!text-[2rem] !text-[#0E1721] leading-[90%] -tracking-[4%] mb-4 text-center max-w-[15.625rem]">
        {t('Welcome to Star Industry')}
      </H1>
      <StringMain className="!text-main-bg/50 mb-8">
        {t("Let's make your money work.")}
      </StringMain>
      <LoginButtonsSection />
      {/* <LoginForm nextLoginStep={nextLoginStep} /> */}
      <StringXSmall className="!text-main-bg/50 text-center !leading-1.2 max-w-[15rem]">
        <Trans
          i18nKey={
            'By clicking Continue, you agree to <1/> the Terms of Service and Privacy Policy.'
          }
          components={{ 1: <br /> }}
        />
      </StringXSmall>
    </article>
  );
};

export { LoginSection };
